<template>
  <li class="indentation-block">
    <div class="indentation-block__illustration">
      <img
        :src="require(`@/assets/illustrations/${infos.illustration}`)"
        class="indentation-block__image"
      />
    </div>
    <div class="indentation-block__text">
      <h2 class="indentation-block__headline">{{ infos.headline }}</h2>
      <p class="indentation-block__description">{{ infos.description }}</p>
      <button class="indentation-block__toggle" @click="togglePreview">Anzeigen</button>
    </div>
  </li>
</template>

<script>
import IndentationPreview from './IndentationPreview.vue'

export default {
  props: {
    infos: {
      type: Object,
      required: true
    }
  },
  components: {
    IndentationPreview
  },
  data () {
    return {
      showPreview: false
    }
  },
  methods: {
    togglePreview () {
      this.$store.dispatch('OPEN_PREVIEW', this.infos.id)
    }
  }
}
</script>

<style lang="scss">
.indentation-block {
  align-items: flex-start;
  display: flex;
  flex-flow: row wrap;
  list-style: none;

  &__illustration {
    flex: 0 0 150px;
  }

  &__text {
    align-self: stretch;
    align-items: flex-start;
    display: flex;
    flex: 1 1 20ch;
    flex-flow: column;
    justify-content: flex-start;
    padding-left: 2vmin;
  }

  &__headline {
    font-size: 1rem;
    margin: 0;
  }

  &__description {
    margin: 1vmin 0 2vmin;
  }

  &__toggle {
    align-self: flex-end;
    margin-top: auto;
  }

  &__preview {
    width: 100%;
  }
}
</style>
